import React from "react";
import { Badge } from "@/components/ui/badge";
import {
  Clock,
  MessageSquare,
  CheckCircle,
  XCircle,
  AlertCircle,
} from "lucide-react";

type InquiryStatus = "new" | "pending" | "responded" | "closed" | "expired";

interface InquiryStatusBadgeProps {
  status: InquiryStatus;
  className?: string;
}

const statusConfig = {
  new: {
    variant: "secondary" as const,
    icon: AlertCircle,
    label: "New",
    color: "text-blue-500",
  },
  pending: {
    variant: "outline" as const,
    icon: Clock,
    label: "Pending",
    color: "text-amber-500",
  },
  responded: {
    variant: "secondary" as const,
    icon: MessageSquare,
    label: "Responded",
    color: "text-green-500",
  },
  closed: {
    variant: "default" as const,
    icon: CheckCircle,
    label: "Closed",
    color: "text-gray-500",
  },
  expired: {
    variant: "destructive" as const,
    icon: XCircle,
    label: "Expired",
    color: "text-destructive",
  },
};

export default function InquiryStatusBadge({
  status,
  className,
}: InquiryStatusBadgeProps) {
  const config = statusConfig[status];
  const Icon = config.icon;

  return (
    <Badge variant={config.variant} className={className}>
      <Icon className={`h-3 w-3 mr-1 ${config.color}`} />
      {config.label}
    </Badge>
  );
}
